itsoftApp.createModule("video", ['windowScroll'], function () {
    const module = this;

    const Video = function () {
        this.names = {
            canPlay: '_can-play',
            playing: '_playing',
            added: '_added',
        }

        this.offsetTop = 150;
        this.delayCheckLoad = 500;

        this.selectors = document.querySelectorAll('.js-video');

        if (this.selectors.length > 0) {
            this.init();
        }
    }

    Video.prototype.init = function () {
        const THIS = this;

        THIS.bindMethods();
        THIS.addListenerScroll();
        THIS.checkLoadAll();
        THIS.onScroll();
    }

    Video.prototype.bindMethods = function () {
        const THIS = this;

        THIS.scrollHandler = THIS.scrollHandler.bind(THIS);
    }

    Video.prototype.addListenerScroll = function () {
        const THIS = this;

        itsoftApp.modules.windowScroll.addEvent(THIS.scrollHandler);
    }

    Video.prototype.scrollHandler = function (e) {
        const THIS = this;

        THIS.onScroll(e);
    }

    Video.prototype.onScroll = function (e) {
        const THIS = this;

        for (const el of THIS.selectors) {
            if (el.classList.contains('js-video-play-now') || (el.classList.contains('js-video-autoplay-mobile') && THIS.isMobile())) {
                THIS.checkPlayNow(el);
            } else if (THIS.isBlockInWindow(el)) {
                THIS.checkPlayOnScroll(el);
            }
        }
    }

    Video.prototype.checkPlayNow = function (el) {
        const THIS = this;

        THIS.addVideo(el);

        if (el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
            THIS.playVideo(el);
        } else {
            setTimeout(() => {
                if ((THIS.getPos(el).bottom - window.innerHeight < 0) && el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
                    THIS.playVideo(el);
                } else {
                    THIS.checkPlayNow(el);
                }
            }, THIS.delayCheckLoad);
        }
    }

    Video.prototype.checkPlayOnScroll = function (el) {
        const THIS = this;

        if (el.classList.contains(THIS.names.canPlay) && !el.classList.contains(THIS.names.playing)) {
            THIS.playVideo(el);
        }

        if (el.classList.contains('js-video-mobile-hide') && window.innerWidth < 768) {

        } else {
            THIS.addVideo(el);
        }
    }

    Video.prototype.addVideo = function(el) {
        const THIS = this;

        if (!el.classList.contains(THIS.names.added)) {
            
            const source = document.createElement('SOURCE');
            if (window.innerWidth > 767 || !el.hasAttribute('data-src-mob')) {
                source.src = el.dataset.src;
            } else {
                source.src = el.dataset.srcMob;
            }
            source.type = 'video/mp4';
            el.appendChild(source)
            el.load()
            el.classList.add(THIS.names.added);
            THIS.checkLoad(el);
        }
    }

    Video.prototype.playVideo = function (el) {
        const THIS = this;

        if (!el.classList.contains('js-video-not-autoplay')) {
            el.oncanplaythrough = function() {
                el.play();
                el.classList.add(THIS.names.playing);
            };
        }

        if (el.classList.contains('js-video-autoplay-mobile') && THIS.isMobile()) {
            el.oncanplaythrough = function() {
                el.play();
                el.classList.add(THIS.names.playing);
            };
        }
    }

    Video.prototype.checkLoad = function (el) {
        const THIS = this;

        if (!el.classList.contains(THIS.names.canPlay) && el.classList.contains(THIS.names.added)) {
            el.classList.add(THIS.names.canPlay);

            if (!el.classList.contains('js-video-with-controls')) {
                el.removeAttribute('controls');
            } else  {
                el.setAttribute("controlslist", "nodownload");
            }
        }
    }

    Video.prototype.checkLoadAll = function () {
        const THIS = this;

        for (const el of THIS.selectors) {
            THIS.checkLoad(el);
        }
    }

    Video.prototype.isBlockInWindow = function (el) {
        const THIS = this;

        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = top - THIS.offsetTop;
        const pointBottom = bottom - THIS.offsetTop;

        // return pointTop < 0 && pointBottom > 0;
        return pointTop < window.innerHeight - 100 && pointBottom > 0;
    }

    Video.prototype.getPos = function (el) {
        const THIS = this;

        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = top - THIS.offsetTop;
        const pointBottom = bottom - THIS.offsetTop;

        return {
            top: pointTop,
            bottom: pointBottom,
        };
    }

    Video.prototype.isMobile = function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    new Video();

    module.callback = Video;
});